exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".board-list-header input[data-v-54f61d50]{border:0;font-size:25px;font-weight:700;font-family:Fira Sans,sans-serif;background:transparent;border-radius:0;max-height:256px;min-height:30px;padding:0;display:block;width:100%;caret-color:#1e73bd}.dev-priorities-ideas[data-v-54f61d50]{padding:0 20px}.board-cart-textarea[data-v-54f61d50]{height:42px}.add-card-btn[data-v-54f61d50]{margin:0 auto}.board-list-box[data-v-54f61d50]{min-height:calc(80vh - 250px)}.right-align[data-v-54f61d50]{margin-left:auto;margin-right:0}", ""]);

// exports
